import React, { memo, ReactNode } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'

interface Props {
  title: string
  subtitle?: string
  /** Rendered in the card head, right of the title — a status chip, a secondary action. */
  actions?: ReactNode
  children: ReactNode
  dataTestId?: string
}

/**
 * The white bordered card that groups one topic on a settings-style page (Settings, Payments,
 * Business): an h4 title with an optional body2 subtitle, then the content as a 16px stack.
 */
const SectionCardComponent = ({ title, subtitle, actions, children, dataTestId }: Props) => {
  return (
    <section
      css={tw`rounded-lg border border-solid border-shades-100 bg-shades-0 p-6`}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      <div css={tw`mb-4 flex flex-row items-start justify-between gap-4`}>
        <div css={tw`min-w-0`}>
          <Typography variant="h4" css={tw`text-shades-900`}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography variant="body2" css={tw`mt-1 text-shades-500`}>
              {subtitle}
            </Typography>
          ) : null}
        </div>
        {actions ? <div css={tw`flex shrink-0 items-center gap-2`}>{actions}</div> : null}
      </div>
      <div css={tw`flex flex-col gap-4`}>{children}</div>
    </section>
  )
}

export const SectionCard = memo(SectionCardComponent)
